import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-work-flow-all-status',
  templateUrl: './work-flow-all-status.component.html',
  styleUrls: ['./work-flow-all-status.component.scss']
})
export class WorkFlowAllStatusComponent implements OnInit {

  @ViewChild('workFlowAllStatusTable', { static: true }) public workFlowAllStatusTable: Table;
  
  public workFlowAllStatusModel: any = [];
  public appId: any;

  public loading: boolean = false;
  public subscriptions: any = [];

  constructor(
    private deptDashBoardService: DepartmentDashboardService, 
    private route: ActivatedRoute,
    private messageService: MessageService,
    private loader: AppLoaderService
  ) { }

  ngOnInit(): void {
    this.appId = this.route.snapshot.params.appId;
    // console.log('appId', this.route.snapshot.params.id);
    this.loadData(this.appId);
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  loadData(appId) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService 
      .workFlowAllStatus(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('Response Data', data);
          this.workFlowAllStatusModel = data;
          // this.loader.close();
          this.loading = false;
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

}
